<section class="role-members">
  <header class="role-members__header">
    <span class="fz-16">{{ title | translate }}</span>
    <span class="color-primary fz14">{{ total }}</span>
  </header>

  <!-- Search is server-side: a client-side filter over the current page would silently hide
       people who are simply on page 3. -->
  <div class="role-members__search p-input-filled-light">
    <input
      type="text"
      pInputText
      class="w-full"
      [attr.aria-label]="'COMMON.TAGS.SEARCH' | translate"
      [placeholder]="'ROLE_MEMBERS.SEARCH_PLACEHOLDER' | translate"
      (input)="onSearch($any($event.target).value)"
    />
  </div>

  <div class="role-members__list">
    @if (loading) {
      @for (row of [1, 2, 3]; track row) {
        <div class="role-members__row"><p-skeleton width="100%" height="1.4rem"></p-skeleton></div>
      }
    } @else {
      @for (member of members; track member.id) {
        <div
          class="role-members__row"
          [class.role-members__row--inactive]="!isActive(member)"
          role="button"
          tabindex="0"
          (click)="rowClick.emit(member)"
          (keydown.enter)="rowClick.emit(member)"
        >
          <p-avatar class="pr-5" shape="circle" [label]="initials(member)" [style]="{ 'background-color': '#C9D4FA' }"></p-avatar>
          <span class="role-members__name">{{ displayName(member) }}</span>
          <span class="role-members__detail fz-12 color-gray2" dir="ltr">{{ displayDetail(member) }}</span>
          @if (!isActive(member)) {
            <span class="role-members__badge fz-12">{{ 'ROLE_MEMBERS.INACTIVE' | translate }}</span>
          }
        </div>
      } @empty {
        <div class="role-members__empty fz-12 color-gray2">
          {{ (search ? 'ROLE_MEMBERS.NO_MATCHES' : 'ROLE_MEMBERS.EMPTY') | translate }}
        </div>
      }
    }
  </div>

  @if (total > rows) {
    <p-paginator [first]="first" [rows]="rows" [totalRecords]="total" (onPageChange)="onPage($event)"></p-paginator>
  }
</section>
